import { Theme } from "@emotion/react";
import { Chip, SxProps } from "@mui/material";
import { ReactNode } from "react";

interface PrimaryChipProps {
  label: ReactNode;
  onDelete?: () => void;
  avatar?: ReactNode;
  deleteIcon?: ReactNode;
  sx?: SxProps<Theme>;
}

const defaultChipSx: SxProps<Theme> = {
  borderRadius: 999,
  fontWeight: 500,
  fontSize: 13,
  paddingY: 1.6,
  paddingX: 0.2,
  backgroundColor: "rgba(0, 110, 255, 0.06)",
  border: "1px solid rgba(0, 110, 255, 0.3)",
};

const PrimaryChip = ({ label, onDelete, avatar, deleteIcon, sx }: PrimaryChipProps) => {
  return (
    <Chip
      size="small"
      label={label}
      onDelete={onDelete}
      avatar={avatar as any}
      deleteIcon={deleteIcon as any}
      sx={{ ...defaultChipSx, ...sx }}
    />
  );
};

export default PrimaryChip;